import ClinicProfileLandingPage from "../container/ClinicProfileLandingPage"
import onBoardingFormContainer from "../container/onBoardingFormContainer";
import ClinicForms from "../components/ClinicInfoForms/ClinicForms";
import LoginForm from "../components/onBoardingForms/steps/LoginForm";

export default [
    {
        title: 'welcomes',
        component: onBoardingFormContainer,
        url: '/public/onboards',
        auth: false,
        exact: true,
    },
    {
        title: 'cliniclanding',
        component: ClinicProfileLandingPage,
        url: '/public/cliniclandingpage/:clinicId',
        auth: false,
        exact: true,
    },
    {
        title: 'ClinicProfile',
        component: ClinicForms,
        url: '/public/clinicProfile',
        auth: false,
        exact: true,
    },
    {
        title: 'Login',
        component: LoginForm,
        url: '/public/login',
        auth: false,
        exact: true
    }
]